'use es6';

import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { colors } from '../../theming/themes/colors';
import { jsx as _jsx } from "react/jsx-runtime";
const Button = styled.div.withConfig({
  displayName: "FaqButton__Button",
  componentId: "m6u4g9-0"
})(["color:", ";border-radius:45px;border:1px solid ", ";margin-left:10px;text-decoration:none;font-size:1em;font-weight:500;display:flex;align-items:center;justify-content:center;height:50px;cursor:pointer;user-select:none;padding:0 25px;"], colors.PRIMARYWHITE, colors.PRIMARYWHITE);
const FaqButton = ({
  onClick
}) => {
  return /*#__PURE__*/_jsx(Button, {
    onClick: onClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "faq.title"
    })
  });
};
export default FaqButton;